import axios from 'axios';

import { identity } from '@altirllc/shared/utils/functionalUtils';

import { handleErrorInterceptor } from '../common';
import * as urls from '../urls';
import { createPrivateApiInterceptors } from './factories';

type TServer = keyof typeof urls;

// request: gatewayInterceptor; response: refreshTokenInterceptor
const privateApiInterceptors = createPrivateApiInterceptors();

const createService = (server: TServer, contentType = 'application/json') => {
  const baseURL = urls[server];
  const headers = { 'Content-Type': contentType };
  const instance = axios.create({ baseURL, headers });

  privateApiInterceptors.apply(instance);
  instance.interceptors.response.use(identity, handleErrorInterceptor);

  return instance;
};

export const profileService = createService('profileServer');
export const accountService = createService('accountServer');
export const stationService = createService('stationServer');
export const geofencePartnerService = createService('geofenceServer');
export const partnerService = createService('partnerServer');
export const stationsSearchService = createService('stationsServer');
export const paymentService = createService('paymentServer');
export const transactionService = createService('transactionServer');
export const walletService = createService('walletServer');
export const configService = createService('configServer');
export const imageService = createService('imageServer', 'multipart/form-data');
// Global search is disabled (see urls.ts). Kept commented so it can be restored.
// export const globalSearchService = createService('globalSearchServer');
// export const recentSearchService = createService('recentSearchServer');
export const dashboardService = createService('dashboardServer');
export const analyticsService = createService('analyticsServer');
export const partnerTransactionsService = createService('partnerTransactionsServer');
export const catalogService = createService('catalogServer');
export const memberService = createService('memberServer');
export const notificationService = createService('notificationServer');
export const supportService = createService('supportServer');
